export const environment = {
  production: true,
  apiUrl: 'https://api.oguzhankircali.com'
  //apiUrl: 'https://localhost:7102'
};
